import { Mail, Calendar, Phone } from "lucide-react";
import { useState } from "react";
import { useGetAuth } from "../../../hooks/useGetAuthHook";
import { formatDate } from "../../../utils/helpers";
import { User } from "../../../types/types";
import UpdateUserModal from "../../../components/modals/UpdateUserModal";
import ProfileLayout from "../../../components/ProfileLayout";
import UpdateUserPhotoModal from "../../../components/modals/UpdateUserPhotoModal";

export default function ProfileDetails() {
  const { data: user, isLoading, error } = useGetAuth<User>("user");
  const [showModal, setShowModal] = useState(false);
  const [showPhotoModal, setShowPhotoModal] = useState(false);

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-stone-50">
        <div className="text-center">
          <div className="w-12 h-12 border-4 border-zinc-200 border-t-orange-600 rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-zinc-600">Loading profile...</p>
        </div>
      </div>
    );
  }

  if (error || !user) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-stone-50">
        <div className="text-center text-red-600">
          <p className="text-lg font-semibold mb-2">Error loading profile</p>
          <p className="text-sm text-zinc-600">
            {error?.message || "No user data found."}
          </p>
        </div>
      </div>
    );
  }

  const infoCards = [
    { icon: Mail, label: "Email", value: user.email },
    { icon: Phone, label: "Phone", value: user.phone },
    { icon: Calendar, label: "Birthday", value: formatDate(user.dob) },
    {
      icon: undefined,
      label: "Gender",
      value: user.gender === "M" ? "Male" : "Female",
      customIcon: (
        <div className="w-6 h-6 rounded-full bg-orange-600 flex items-center justify-center text-white text-xs font-bold">
          {user.gender}
        </div>
      ),
    },
  ];

  const handleEditClick = () => {
    setShowModal(true);
  };

  const handleSuccess = () => {
    window.location.reload();
  };

  const handleOpenPhotoModal = () => {
    setShowModal(false);
    setShowPhotoModal(true);
  };

  return (
    <div className="min-h-screen bg-stone-50">
      <ProfileLayout
        user={user}
        infoCards={infoCards}
        isEditable={true}
        onEdit={handleEditClick}
      />
      {showModal && (
        <UpdateUserModal
          user={user}
          onClose={() => setShowModal(false)}
          onSuccess={handleSuccess}
          onOpenPhotoModal={handleOpenPhotoModal}
          invalidateKey={["user"]}
        />
      )}
      {showPhotoModal && (
        <UpdateUserPhotoModal
          user={user}
          onClose={() => setShowPhotoModal(false)}
          onSuccess={handleSuccess}
          invalidateKey={["user"]}
        />
      )}
    </div>
  );
}
